import { render, staticRenderFns } from "./CourseraLanding.vue?vue&type=template&id=f1f9f1d8&scoped=true&"
import script from "./CourseraLanding.vue?vue&type=script&lang=ts&"
export * from "./CourseraLanding.vue?vue&type=script&lang=ts&"
import style0 from "./CourseraLanding.vue?vue&type=style&index=0&id=f1f9f1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f9f1d8",
  null
  
)

export default component.exports